import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../shared/utilities/api.service";
import { DiscussionBookmark } from "../../models";

@Injectable()
export class BookmarkService {
  constructor(private apiService: ApiService) {}

  public updateOne(discussionSlug: string): Observable<DiscussionBookmark> {
    // POST /api/discussions/:discussions/bookmark
    const deleteURL = `/discussions/${discussionSlug}/bookmark`;
    return this.apiService.post(deleteURL);
  }
}
